import { Link } from "react-router-dom";
import { Lock, ArrowLeft } from "@phosphor-icons/react";
import Logo from "@/components/Logo";

export default function RequestInvite() {
  return (
    <div className="min-h-screen text-white font-body">
      <div className="max-w-2xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <Link to="/" data-testid="request-back-home" className="inline-flex items-center">
          <Logo variant="nav" alt="Hunt57" />
        </Link>

        <h1 className="mt-8 font-display font-black uppercase text-4xl md:text-5xl tracking-tighter leading-none">
          Request an Invite
        </h1>

        {/* Unavailable notice */}
        <div className="mt-10 h57-surface p-6 md:p-8 relative overflow-hidden" data-testid="request-unavailable-notice">
          <div className="absolute inset-0 bg-zinc-500/5 pointer-events-none" />
          <div className="relative">
            <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-zinc-500">
              <Lock size={14} weight="bold" /> Currently Unavailable
            </div>
            <h2 className="mt-4 font-display font-black uppercase text-2xl md:text-3xl tracking-tight text-zinc-300">
              Requesting an invite is not currently available.
            </h2>
            <p className="mt-4 text-zinc-400 leading-relaxed text-base">
              Know a Hunt57 member? Ask them for an invite! Every account in the community is here because someone
              vouched for them — that's how we keep it clean.
            </p>
            <p className="mt-4 text-zinc-500 text-sm">
              Already have an invite code?{" "}
              <Link to="/register" className="text-[#FF5F1F] hover:underline font-bold" data-testid="request-link-register">
                Redeem it here →
              </Link>
            </p>
          </div>
        </div>

        {/* Grayed-out form preview */}
        <div className="mt-8 relative pointer-events-none select-none" aria-hidden="true" data-testid="request-form-disabled">
          <div className="absolute inset-0 bg-[#0A0A0A]/70 z-10 flex items-center justify-center">
            <div className="font-mono text-[11px] uppercase tracking-widest text-zinc-600 border border-zinc-800 px-4 py-2 bg-[#0A0A0A]">
              → Form Disabled
            </div>
          </div>
          <div className="space-y-4 opacity-30 blur-[1px]">
            <div>
              <label className="h57-label">Your Name</label>
              <input disabled className="h57-input" placeholder="Jane Collector" />
            </div>
            <div>
              <label className="h57-label">Email</label>
              <input disabled className="h57-input" placeholder="you@example.com" />
            </div>
            <div>
              <label className="h57-label">Instagram / Social (optional)</label>
              <input disabled className="h57-input" placeholder="@your_hobby_handle" />
            </div>
            <div>
              <label className="h57-label">What do you collect?</label>
              <textarea disabled className="h57-input min-h-[100px]" />
            </div>
            <button disabled className="h57-btn-primary w-full">Submit Request</button>
          </div>
        </div>

        {/* Return home button */}
        <div className="mt-10 flex justify-center">
          <Link to="/" data-testid="request-return-home" className="h57-btn-secondary inline-flex items-center gap-2">
            <ArrowLeft size={14} weight="bold" /> Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
